import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { ICompanyState } from './company.slice';

/**
 A selector function to retrieve the Company profile data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {ICompanyState} The Company profile state object from the Redux store
 */
const selectCompanyState = (state: TRootState): ICompanyState => state.company;

/**
 A memoized selector function to retrieve the Company profile data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ICompanyState, (res: ICompanyState) => ICompanyState>}
 */
export const getCompanyState = createSelector(
  [selectCompanyState],
  (state): ICompanyState => state
);
